export default __webpack_public_path__ + "static/media/Peach_Herald.8e53298f.jpeg";